import React from 'react';
import { useNavigate } from 'react-router-dom';
import Snowfall from 'react-snowfall';
import Button from '../../common/Button/Button';
import headingImg from '../../../assets/lottie/heading.png';
import './Home.css';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      {/* ❄️ SNOW BACKGROUND */}
      <Snowfall
  snowflakeCount={120}
  color="#adcef7ff"
  style={{
    position: 'fixed',
    width: '100vw',
    height: '100vh',
    zIndex: 1,
    pointerEvents: 'none',
  }}
/>

      {/* MAIN CONTENT */}
      <div
        className="home-card"
        style={{
          position: 'relative',
          zIndex: 2, // ⬅️ ensures content is above snow
        }}
      >
        {/* Heading Image */}
        <img
          src={headingImg}
          alt="Chillai Kalan Idea Challenge"
          className="home-heading-image"
        />

        {/* Subtitle */}
        <p className="home-subtitle">
          Share your innovative ideas to solve real problems faced during
          harsh winters.
        </p>

        {/* Instructions */}
      <section className="instructions">
  <h3>How to submit your idea</h3>
<ol className="instruction-list">
  <li className="instruction-item">
    <div className="step-content">
      <span className="step-badge">1</span>

      <div className="step-text">
        <strong>Choose a Theme</strong>
        <span>Select the problem area where your idea fits best.</span>
      </div>
    </div>
  </li>

  <li className="instruction-item">
    <div className="step-content">
      <span className="step-badge">2</span>

      <div className="step-text">
        <strong>Describe Your Idea</strong>
        <span>
          Explain the problem, who is affected, why it exists, and your proposed solution.
        </span>
      </div>
    </div>
  </li>

  <li className="instruction-item">
    <div className="step-content">
      <span className="step-badge">3</span>

      <div className="step-text">
        <strong>Enter Your Details</strong>
        <span>
          Provide your name, contact details, district, and team information if applicable.
        </span>
      </div>
    </div>
  </li>

  <li className="instruction-item">
    <div className="step-content">
      <span className="step-badge">4</span>

      <div className="step-text">
        <strong>Review & Submit</strong>
        <span>Verify all information and submit your idea.</span>
      </div>
    </div>
  </li>
</ol>

</section>

        {/* CTA */}
        <div className="home-cta-wrapper">
          <Button size="large" onClick={() => navigate('/submit')}>
            Submit Your Idea
          </Button>
        </div>
      </div>
    </div>
  );
}
